"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ck_editor_component_1 = require("./ck-editor.component");
exports.CKEditorComponent = ck_editor_component_1.CKEditorComponent;
var ck_editor_module_1 = require("./ck-editor.module");
exports.CKEditorModule = ck_editor_module_1.CKEditorModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-ckeditor/lib/index.js
// module id = 390
// module chunks = 323